import Icon from '@klv/atoms/icon';

import { generateClassName, getAuthorName, ucFirst } from '@klv/shared/utils/functions';
import { socialNetworks } from './types';

import * as styles from './styles/authors.module.scss';

import type { IAuthorProps, IStaticAuthorsLayout } from './types';


const defaultAuthorImageJpg = '/static/author/author-image-fallback.jpg';
const defaultAuthorImageWebP = '/static/author/author-image-fallback.webp';


export const Author = ({ author, className, isArchive, ...props }: IAuthorProps) => {
  const hasSocialLinks = socialNetworks.some((network) => author.usersAuthor?.[network]);
  const profilePhoto = author?.usersAuthor?.profilePhoto?.sourceUrl;

  return (
    <div className={generateClassName([className, styles.authorContainer, isArchive && styles.isArchive])} {...props}>
      {profilePhoto ? (
        <img
          alt={author.name}
          className={styles.authorImage}
          sizes={author?.usersAuthor?.profilePhoto?.sizes}
          src={profilePhoto}
          srcSet={author?.usersAuthor?.profilePhoto?.srcSet}
        />
      ) : (
        <picture className={styles.authorImageFallback}>
          <source srcSet={defaultAuthorImageWebP} type='image/webp' />
          <source srcSet={defaultAuthorImageJpg} type='image/jpeg' />
          <img src={defaultAuthorImageJpg} alt={author.name} />
        </picture>
      )}
      <div className={styles.authorDetails}>
        {!isArchive && (
          <>
            <div className={styles.authorName}>{getAuthorName(author.name, author?.firstName, author?.lastName)}</div>
            {author.usersAuthor?.jobTitle && <div className={styles.authorTitle}>{author.usersAuthor.jobTitle}</div>}
          </>
        )}
        {author?.description && <div className={styles.authorDescription}>{author.description}</div>}
        {hasSocialLinks && (
          <div className={styles.socialAuthorLinks}>
            {socialNetworks.map((authorLink, index) => (
              author.usersAuthor?.[authorLink] && (
                <a key={author.usersAuthor[authorLink]} href={author.usersAuthor[authorLink]} target="_blank">
                  <Icon className={styles.styledCoAuthorIcon} iconName={ucFirst(socialNetworks[index]) as Capitalize<typeof authorLink>} />
                </a>
              )
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Authors = ({ authors, className, noTableOfContents, isArchive }: IStaticAuthorsLayout) => (
  <div
    className={generateClassName([
      className,
      'grid',
      styles.styledAuthors,
      (authors?.length < 2) && styles.singleAuthor,
      isArchive && styles.isArchive,
      noTableOfContents && styles.noTableOfContents,
    ])}
  >
    {authors.map((author) => (
      <Author author={author} isArchive={isArchive} key={author.name} />
    ))}
  </div>
);

export default Authors;
